import { useState } from "react";
import { Nav, NavLink, NavItem } from "reactstrap";
import { SearchTabsPropsType } from "../../Type/SearchType";
import { NAV_DATA } from "../../Data/SearchResult";

const SearchTabs = ({ callbackActive,activeTabValue }: SearchTabsPropsType) => {
  const [activeTab, setActiveTab] = useState(activeTabValue);
  
  const handleTab = (id: number | undefined) => {
    if (id) {
      setActiveTab(id);
      callbackActive(id);
    }
  };
  
  return (
    <div className="text-center">
    <Nav tabs className="search-list">
      {NAV_DATA.map((data, index) => (
        <NavItem className={data.navItemClass ? data.navItemClass : ""} key={index}> 
          <NavLink className={activeTab === index + 1 ? "active" : ""} onClick={() => handleTab(data.id)}>
            {data.icon}
            {data.tittle}
          </NavLink>
          <div className="material-border"></div>
        </NavItem>
      ))}
    </Nav>
    </div>
  );
};
export default SearchTabs;
